import {ConfigObjectType, useApiQuery} from '@wallaby-ui/core';

import {AlertPatientListPage} from './alert_list_types';

type UseAlertPatientListReturn = {
  page: AlertPatientListPage | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
};

/**
 * The alerts list read (PDW-183): `GET {alertPatientList}` with the filter, the page and the sorts as query parameters,
 * a set as one comma-separated value. Paged and counted by patient. Fetched again on every mount, filter change and
 * after every action on an episode: episodes change without anything the product stores changing (no ETag).
 */
export function useAlertPatientList(config: ConfigObjectType, params: URLSearchParams, enabled: boolean): UseAlertPatientListReturn {
  const url: string = config.service.url.alertPatientList ?? '';
  const {data, isLoading, isError, refetch} = useApiQuery<AlertPatientListPage>([url, String(params)], null, {
    axiosConfig: {url, params},
    reactQueryOptions: {
      enabled: enabled && Boolean(url),
      staleTime: 0,
      refetchOnMount: 'always',
      keepPreviousData: true,
    },
  });
  return {page: data, isLoading, isError, refetch};
}
